<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1></h1>
<p style="text-align: center;"><strong>Create a world where everyone feels loved, and nurtures one’s full potential to live a fulfilling life.</strong></p><br/>
<p style="text-align: center;">Thank you so much for your kind contribution – we have teamed up with Share the Meal and Smiling Gecko to provide food to those in need.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6e314ec8